import {put, select, takeEvery} from 'redux-saga/effects';
import _ from "lodash";
import {TYPES as ROOM_MESSAGE_TYPES} from '../creators/room.message';
import {TYPES as ROOM_MESSAGES_TYPES} from '../creators/room.messages';
import {TYPES as ROOM_MEDIAS_TYPES} from "../creators/room.medias";

export const getRoomMedias = (state) => state.roomMedias.data;

export function* interceptMessageMedia(action) {
    try {
        let roomMessage = _.get(action, "payload._id") ? action.payload : _.get(action, "payload.roomMessage");
        if (roomMessage && roomMessage.kind === "gallery" && !roomMessage.isDeleted) {
            let roomMedias = yield select(getRoomMedias);
            if (!roomMedias.find(roomMedia => roomMedia._id === roomMessage._id)) {
                yield put({type: ROOM_MEDIAS_TYPES.ADD, payload: roomMessage});
            }
        }
    } catch (error) {

    }
}

export function* interceptMessageMediaUpdate(action) {
    try {
        let roomMessage = _.get(action, "payload._id") ? action.payload : _.get(action, "payload.roomMessage");
        if (roomMessage && roomMessage.kind === "video" && !roomMessage.isDeleted && _.get(roomMessage,"file.state") === 1) {
            let roomMedias = yield select(getRoomMedias);
            if (!roomMedias.find(roomMedia => roomMedia._id === roomMessage._id)) {
                yield put({type: ROOM_MEDIAS_TYPES.ADD, payload: roomMessage});
            }
        }
    } catch (error) {

    }
}

export function* removeMessageMedia(action) {
    try {
        let roomMessage = _.get(action, "payload._id") ? action.payload : _.get(action, "payload.roomMessage");
        if (roomMessage && roomMessage.isDeleted && (roomMessage.kind === "gallery" || roomMessage.kind === "video")) {
            let roomMedias = yield select(getRoomMedias);
            if (roomMedias.find(roomMedia => roomMedia._id.toString() === roomMessage._id.toString())) {
                yield put({type: ROOM_MEDIAS_TYPES.REMOVE, _id: roomMessage._id});
            }
        }
    } catch (error) {

    }
}

export function* watchRoomMessage() {
    yield takeEvery([ROOM_MESSAGE_TYPES.CREATE_SUCCESS, ROOM_MESSAGES_TYPES.SUBSCRIBE_DATA], interceptMessageMedia);
    yield takeEvery([ROOM_MESSAGE_TYPES.UPDATE_SUCCESS, ROOM_MESSAGES_TYPES.SUBSCRIBE_DATA], interceptMessageMediaUpdate);
    yield takeEvery([ROOM_MESSAGE_TYPES.DELETE_SUCCESS, ROOM_MESSAGES_TYPES.SUBSCRIBE_DATA], removeMessageMedia);
}

export default watchRoomMessage;

